import { render, staticRenderFns } from "./ConfigurationsEdit.vue?vue&type=template&id=310d91b6"
import script from "./ConfigurationsEdit.vue?vue&type=script&lang=js"
export * from "./ConfigurationsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports